/* eslint-disable complexity */

import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import { useTranslations } from '@unisporkal/localization';
import styles from './AcquisitionTitle.module.scss';
import acquisitionTypes from '../../support/acquisitionTypes.ts';

const TitleTabs = ({
  availableAcquisitionTypes = [],
  onTabClick = () => {},
  acquisitionType = '',
  downloadAcquisitionTitle = '',
}) => {
  const t = useTranslations();
  const multiTabs = useMemo(
    () => availableAcquisitionTypes.length > 1,
    [availableAcquisitionTypes]
  );

  return (
    <div
      className={styles.titleTabs}
      data-testid="acquisition-title-container"
    >
      {availableAcquisitionTypes.map((acqType) => {
        const customDownloadTitle =
          acqType.type === acquisitionTypes.DOWNLOAD ||
          acqType.type === acquisitionTypes.PREVIEW ||
          acqType.type === acquisitionTypes.MODIFIED_DOWNLOAD;
        const acquisitionTitle = customDownloadTitle
          ? downloadAcquisitionTitle
          : acqType.title;

        if (multiTabs) {
          return (
            <button
              type="button"
              className={cx(styles.title, styles.titleBtn)}
              key={acqType.type}
              onClick={() => onTabClick(acqType)}
              data-testid="title-tab"
            >
              <div
                className={cx(
                  styles.titleLink,
                  acquisitionType === acqType.type ? styles.selected : '',
                  styles.actionEmphasis
                )}
              >
                {acquisitionTitle ? t(acquisitionTitle) : null}
              </div>
            </button>
          );
        }
        return (
          <div
            className={cx(styles.title, styles.titleBtn)}
            key={acqType.type}
            data-testid="title-tab-text"
          >
            <div
              suppressHydrationWarning
              className={cx(
                styles.titleLink,
                acquisitionType === acqType.type ? styles.selected : '',
                styles.textLinkNoHover
              )}
            >
              {acquisitionTitle ? t(acquisitionTitle) : null}
            </div>
          </div>
        );
      })}
    </div>
  );
};

TitleTabs.propTypes = {
  availableAcquisitionTypes: PropTypes.arrayOf(
    PropTypes.shape({ title: PropTypes.string, type: PropTypes.string })
  ),
  onTabClick: PropTypes.func,
  acquisitionType: PropTypes.string,
  downloadAcquisitionTitle: PropTypes.string,
};

export default TitleTabs;
